/**
 * 字典关接口
 */
const PREFIX = 'checkmall-system'
export default {
  /**
   * 接口模块 前缀
   */
  prefix: PREFIX,
  url: {
    getDicList: '/api/dic/list',
  },
}
